import type { ProductDto } from './dto';
import type { Product } from './model';

export const mapServiceProductsDtoToModel = (products: ProductDto[] = []): Product[] => {
  return (
    products
      // NOTE: we only have products on sites today, but if that ever changes we can update it here
      // filter for sites only to avoid some unexpected behavior in the future
      .filter((product) => product.entity.entity_type === 'site')
      .map((product) => ({
        sku: product.sku,
        entity: {
          id: String(product.entity.entity_identifier),
          type: product.entity.entity_type,
          label: product.entity.entity_label,
        },
      }))
  );
};
